import { useSyncExternalStore } from 'react'

/**
 * Store versi kecil untuk reaktivitas data lokal (IndexedDB tak auto-observe).
 * `bump()` setelah data berubah → komponen yang memakai `useVersion()` re-query.
 * `channelName` (opsional): siarkan ke tab lain lewat BroadcastChannel supaya
 * tab lain yang membuka kasir/riwayat ikut ter-refresh.
 */
const createVersionStore = (channelName) => {
  let version = 0
  const listeners = new Set()

  const notify = () => {
    version += 1
    listeners.forEach((listener) => listener())
  }

  let channel = null
  if (channelName && typeof window !== 'undefined' && 'BroadcastChannel' in window) {
    channel = new window.BroadcastChannel(channelName)
    channel.onmessage = notify
  }

  const bump = () => {
    notify()
    channel?.postMessage(version)
  }

  const subscribe = (listener) => {
    listeners.add(listener)
    return () => {
      listeners.delete(listener)
    }
  }

  const getSnapshot = () => version

  const useVersion = () => useSyncExternalStore(subscribe, getSnapshot)

  return { bump, subscribe, getSnapshot, useVersion }
}

export default createVersionStore
